import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import styled from 'styled-components';
import { Box } from '@yoweb/ui/components/Box';
import { th } from '@yoweb/ui/styles/utils/theme';
import { jsx as _jsx } from "react/jsx-runtime";
export var CallCard = function CallCard(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(BorderBox, _objectSpread(_objectSpread({
    radii: "small",
    backgroundColor: "base000",
    p: "normal1",
    display: "flex",
    flexDirection: "column",
    gap: "normal1"
  }, rest), {}, {
    children: children
  }));
};
var BorderBox = styled(Box).withConfig({
  componentId: "sc-1yvfmj7-0"
})(["&&{border:1.5px solid ", ";position:relative;transition:border-color ", "ms ease-out;cursor:", ";&:hover{border-color:", ";}}"], th.getColor('sand'), th.getDuration('interaction'), function (_ref2) {
  var hoverable = _ref2.hoverable;
  return hoverable ? 'pointer' : 'default';
}, function (_ref3) {
  var _ref3$hoverable = _ref3.hoverable,
      hoverable = _ref3$hoverable === void 0 ? true : _ref3$hoverable;
  return hoverable ? th.getColor('sandDark') : th.getColor('sand');
});